import { getMobileOS } from '@strava/utils';
import { MOBILE_OS } from '@strava/constants/src/appConstants';
import { APP_STORES } from './constants';

export const mobileOsToAppStore = (userAgent) => {
  switch (getMobileOS(userAgent)) {
    case MOBILE_OS.android:
      return APP_STORES.google;
    case MOBILE_OS.iPhone:
    case MOBILE_OS.iPad:
      return APP_STORES.apple;
    default:
      return APP_STORES.unknown;
  }
};
